import { getFetchedDataPayload } from '../../../../utils/fetched-data/get-fetched-data-payload';
import { getTicketTypeById } from '../../../sales-data/selectors/tickets/get-ticket-type-by-id';
import { orderDomainStore } from '../../store';
export const getOrderRelatedTicketTypeById = (ticketTypeId) => {
    return (getFetchedDataPayload(orderDomainStore.data.ticketTypesById[ticketTypeId]) || getTicketTypeById(ticketTypeId));
};
